import React, { useEffect, useRef, useState } from 'react';
import { array, string, bool, number, func} from 'prop-types';
import ReactTable from 'react-table';
import treeTableHOC from 'react-table/lib/hoc/treeTable';
import { advancedExpandTableHOC } from 'react-table/lib/hoc/advancedExpandTable';
import "react-table/react-table.css";
import { GLOBAL } from '../../Config/global';
import "react-table/react-table.css";
import ConfirmationModal from '../ConfirmationModal';
import LoadingTable from '../LoadingTable';


const SelectTable = treeTableHOC(ReactTable);
const ExpandTable = advancedExpandTableHOC(ReactTable);
const renderSpan = (spanClass) => (
  <span className={spanClass} />
);
const TextProps = {
  previousText: renderSpan('before-btn'),
  nextText: renderSpan('after-btn'),
  ofText: GLOBAL.TABLE_VIEW.OF_TEXT,
  rowsText: GLOBAL.TABLE_VIEW.ROWS_TEXT,
  pageText: GLOBAL.TABLE_VIEW.PAGE_TEXT
};
const Table = ({ 
  history,
  columns,
  className,
  data,
  defaultPageSize,
  filterable,
  onSortedChange,
  onPageSizeChange,
  changePage,
  loading,
  filter,
  sorted,
  manual, 
  onKeyDown,
  pages,
  page,
  onFilterChange,
  pageSize,
  expandable,
  subComponent }) => {
  const [selection, setSelection] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);

  const tableElementRef = useRef(null);

  const toggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const toggleExportModal = () => {
    setShowExportModal(!showExportModal);
  };

  const onSuccessRedirect = () => {
    history.push('/table-success');
  };

  const toggleAllSelection = () => {
    if (selectAll) {
      const wrappedInstance = tableElementRef.current.getWrappedInstance();
      const currentRecords = wrappedInstance.getResolvedState().sortedData;

      setSelection(currentRecords.map(record => `select-${record._original.id}`))
    } else {
      setSelection([]);
    }
  };

  const toggleSingleSelection = key => {
    const keyIndex = selection.indexOf(key);
    if (keyIndex >= 0) {
      setSelection([
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ]);
    } else {
      setSelection([
        ...selection,
        key
      ]);
    }
  };

  const isSelected = key => selection.includes(`select-${key}`);

  const isEditing = key => editingRow && editingRow.index === key;
  
  // eslint-disable-next-line no-nested-ternary
  const getSelectedRowProps = rowInfo => (rowInfo && isSelected(rowInfo.original.id)) ? "-selected" : (rowInfo && selection.length && !isSelected(rowInfo.original.id) ? '-disabled' : '');
  
  // eslint-disable-next-line no-nested-ternary
  const getEditingRowProps = rowInfo => rowInfo && isEditing(rowInfo.index) ? "-editing" : rowInfo && editingRow && !isEditing(rowInfo.index) ? '-disabled' : '';

  const getRowProps = (state, rowInfo) => ({
    className: `${getSelectedRowProps(rowInfo)} ${getEditingRowProps(rowInfo)}`
  });
  useEffect(() => {
    toggleAllSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAll]);


  //Inicio Control Scroll Flotante
  let refDivTable = React.createRef()
  let refDivScroll1 = React.createRef()
  let refDivScroll2 = React.createRef()

  useEffect(() => {
    if (refDivTable.current) {
      setWidthDivScroll();
    }
  });

  useEffect(() => {
    setTopDivScroll();
  });


  const scrollHorizontalTable = () => {
    setWidthDivScroll();
    refDivTable.current.scrollLeft = refDivScroll1.current.scrollLeft
  };

  const calculateWidthDivScroll = () => {
    try {
      return (refDivTable.current && refDivTable.current.scrollWidth) ? refDivTable.current.scrollWidth : window.innerWidth+10;
    }
    catch {
      console.log("Error calculando width del scroll de la tabla")
      return window.innerWidth+10;
    }
  }

  const calculateTopDivScroll = () => {
    try {
      const footer = document.querySelector("div.footer-container");
      if ((footer) && (footer.offsetTop + footer.offsetHeight <= window.innerHeight)){
        return window.innerHeight - footer.offsetHeight - 20;
      }
      else {
        return window.innerHeight - 20;
      }
    }
    catch {
      console.log("Error calculando top del scroll de la tabla")
      return 0;
    }
  }

  const setWidthDivScroll = () => {
    refDivScroll2.current.style.width = calculateWidthDivScroll().toString() + "px";
  }

  const setTopDivScroll = () => {
    refDivScroll1.current.style.top = calculateTopDivScroll().toString() + "px";
  }

  //Fin Control Scroll Flotante

  return (
    <React.Fragment>
      {showDeleteModal && <ConfirmationModal
        message={GLOBAL.TABLE_VIEW.DELETE_MODAL_BODY}
        status="warning"
        title={GLOBAL.TABLE_VIEW.DELETE_MODAL_TITLE}
        onDismiss={toggleDeleteModal} 
        onConfirm={onSuccessRedirect} 
      />}
      {showExportModal && <ConfirmationModal
        message={GLOBAL.TABLE_VIEW.EXPORT_MODAL_BODY}
        title={GLOBAL.TABLE_VIEW.EXPORT_MODAL_TITLE}
        status="primary"
        onDismiss={toggleExportModal}
        onConfirm={onSuccessRedirect}
      />}

      <div ref={refDivScroll1} onScroll={scrollHorizontalTable}
        style={{ 
          overflow: "auto",
          position: "sticky",
          zIndex: "1",
          top: calculateTopDivScroll().toString() + "px"
        }}
      >
        <div ref={refDivScroll2} style={{
            width: calculateWidthDivScroll().toString() + "px",
            height: "1px"
          }}>
        </div>
      </div> 

      <div ref={refDivTable} style={{overflow: "hidden", marginBottom: "20px"}}>
          
      {!expandable && <SelectTable
       {...TextProps}
        ref={tableElementRef}
        onKeyDown={onKeyDown}
        data={data}
        pageSize={pageSize}
        manual={manual}
        loading={loading}
        pages={pages}
        filterable={filterable}
        filtered={filter}
        onFilteredChange={onFilterChange}
        defaultPageSize={defaultPageSize}
        minRows={1}
        page={page}
        defaultFilterMethod={(filter, row) =>
           row._original[filter.id].toString().toLowerCase().includes(filter.value.toString().toLowerCase()
           )}
        toggleSelection={toggleSingleSelection}
        toggleAll={() => setSelectAll(!selectAll)}
        selectAll={selectAll}
        resizable={false}
        isSelected={isSelected}
        onSortedChange={onSortedChange}
        columns={columns}
        sorted={sorted}
        sortable
        getTrProps={getRowProps}
        onPageChange={changePage}
        onPageSizeChange={onPageSizeChange}
        className={`-striped -highlight ${className}`}           
        LoadingComponent={LoadingTable}
      />}

      {expandable && <ExpandTable
       {...TextProps}
       LoadingComponent={LoadingTable}
        ref={tableElementRef}
        data={data}        
        manual={manual}
        loading={loading}
        pageSize={pageSize}
        onFilteredChange={onFilterChange}
        pages={pages}
        page={page}
        filtered={filter}
        sorted={sorted}
        filterable={filterable}
        defaultPageSize={defaultPageSize}
        minRows={1}
        defaultFilterMethod={(filter, row) =>
           row._original[filter.id].toString().toLowerCase().includes(filter.value.toString().toLowerCase()
           )}
        toggleSelection={toggleSingleSelection}
        toggleAll={() => setSelectAll(!selectAll)}
        selectAll={selectAll}
        resizable={false}
        isSelected={isSelected}
        onSortedChange={onSortedChange}
        showPageJump={false}
        columns={columns}
        onPageChange={changePage}
        onPageSizeChange={onPageSizeChange}
        sortable
        getTrProps={getRowProps}
        className={`-striped -highlight ${className}`}
        SubComponent={subComponent}        
      />}

      </div> 
      
    </React.Fragment>
  );
}

Table.propTypes = {
  className: string,
  columns: array.isRequired,
  filterable: bool,
  defaultPageSize: number,
  data: array.isRequired,
  keyField: string,
  resizable: bool,
  getTableRef: func,
  onPageSizeChange :func,
  defaultSortingMethod: func,
  handleToggleAllSelection: func,
  handleToggleSingleSelection: func,
  handleSetSelectAll: func,
  getRowProps: func,
  selectInputComponent: func,
  selectAll: bool,
  isSelected: func,
  manual: bool,
  pageSize : number,
  onFilterChange: func,
  onSortedChange: func,
  loading: bool,
  pages: number,  
  page: number,  
  expandable: bool,
  subComponent: func
};

Table.defaultProps = {
  className: "",
  pageSize:10,
  keyField: "id",
  defaultPageSize: 10,
  filterable: true,
  resizable: true,
  selectAll: false,
  loading: false,
  manual: false,
  sorted: [],  
  isSelected: () => false,
  defaultSortingMethod: () => null,
  handleToggleAllSelection: () => null,
  handleToggleSingleSelection: () => null,
  handleSetSelectAll: () => null,
  getRowProps: () => ({
      className: ``
  }),
  selectInputComponent: () => null,
  onSortedChange: () => null  ,
  expandable: false,
  subComponent: null
};
export default Table;
